export default "__VITE_ASSET__CX_Aedc5__"